export default "__VITE_ASSET__BHxu2f_s__"